import { CREATE_REPORT_LOADING, CREATE_REPORT_SUCCESS, CREATE_REPORT_FAILED } from "../actions/soundManager.action"
import { ReportCreateReducer } from "../models/reportCreate.interface"

const initialState: ReportCreateReducer = {
    reportCreateLoading: true,
    reportCreateError: false,
    reportCreateMessage: "",
    reportCreateData: [],
    inProgress: false,
}

const reportCreateReducer = (state: ReportCreateReducer = initialState, action: any): ReportCreateReducer => {
    switch (action.type) {
        case CREATE_REPORT_LOADING:
            return {
                ...state,
                reportCreateLoading: true,
                reportCreateError: false,
                reportCreateData: [],
                inProgress:true,
            }
        case CREATE_REPORT_SUCCESS:
            return {
                ...state,
                reportCreateLoading: false,
                reportCreateError: false,
                reportCreateData: action.payload.res.data,
                inProgress:false,
            }
        case CREATE_REPORT_FAILED:
            return {
                ...state,
                reportCreateLoading: false,
                reportCreateError: true,
                reportCreateMessage: action.payload || "",
                inProgress:false
            }
        default:
            return state;
    }
}

export default reportCreateReducer;